import { createSlice } from "@reduxjs/toolkit";

const users = createSlice({
  name: "users",
  initialState: {},
  reducers: {
    updateUsers: (state, action) => {
      const users = action.payload;

      if (users && Array.isArray(users)) {
        users.forEach(
          (user) => (state[user.id] = { ...state[user.id], ...user })
        );
      }

      return state;
    },
    updateUsersTop: (state, action) => {
      const users = action.payload;

      if (users && Array.isArray(users)) {
        users.forEach(
          (user, index) =>
            (state[user.id] = { ...state[user.id], positionInTop: index + 1 })
        );
      }
    },
    updateUsersWork: (state, action) => {
      for (let userId in state) {
        state[userId].work = [];
      }

      const work = action.payload;

      if (work && Array.isArray(work)) {
        work.forEach((workPart) => {
          if (state[workPart.moderator_id]) {
            state[workPart.moderator_id].work.push({
              ...workPart,
              ban_number_percent:
                workPart.ban_number > 0
                  ? Math.round(
                      (workPart.payer_ban_number / workPart.ban_number) * 100
                    )
                  : 0,
              irrelevant_ban_number_percent:
                workPart.ban_number > 0
                  ? Math.round(
                      (workPart.irrelevant_ban_number / workPart.ban_number) * 100
                    )
                  : 0,
              unban_number_percent:
                workPart.unban_number > 0
                  ? Math.round(
                      (workPart.payer_unban_number / workPart.unban_number) * 100
                    )
                  : 0,
              innefective:
                workPart.total_interval_number > 0
                  ? Math.round(
                      (1 -
                        workPart.efficient_interval_number /
                          workPart.total_interval_number) *
                        100
                    )
                  : 0,
            });
          }
        });

        const disratedData = work.reduce((result, workPart) => {
          if (!result[workPart.moderator_id]) {
            result[workPart.moderator_id] = { total: 0, disrated: 0 };
          }
          result[workPart.moderator_id].total += workPart.total_interval_number;
          result[workPart.moderator_id].disrated +=
            workPart.disrated_interval_number || 0;

          return result;
        }, {});

        for (let userId in disratedData) {
          if (state[userId]) {
            state[userId].disrated =
              disratedData[userId].total > 0
                ? disratedData[userId].disrated / disratedData[userId].total
                : 0;
          }
        }
      }

      return state;
    },
  },
});

export const { updateUsers, updateUsersTop, updateUsersWork } = users.actions;

export const selectUserById = (userId) => (state) => state.users[userId];
export const selectUsersByIds = (userIds) => (state) =>
  userIds
    .filter((userId) => state.users[userId])
    .map((userId) => state.users[userId]);
export const selectAllUsers = (state) => Object.values(state.users);
export const selectUsersByOptions =
  ({
    kyiv,
    kr,
    imageModerators,
    imageDollarModerators,
    reportModerators,
    textModerators,
    admins,
    superadmins,
    indonesia,
    server,
    midfingerModerators,
  }) =>
  (state) => {
    return Object.values(state.users).filter((user) => {
      if (user.name === "Server") return server;
      if (user.by_indonesia) return indonesia;

      return (
        ((user.group === "default" && kyiv) ||
          (user.group === "anton" && kr)) &&
        ((user.role === "moderator" && user.disrated >= 1 && imageModerators) ||
          (user.role === "moderator" &&
            user.disrated < 1 &&
            imageDollarModerators) ||
          (user.role === "report_moderator" && reportModerators) ||
          (user.role === "text_moderator" && textModerators) ||
          (user.role === "supermoderator" && admins) ||
          (user.role === "admin" && superadmins) ||
          (user.role === "midfinger_moderator" && midfingerModerators))
      );
    });
  };

export default users;
